export default __webpack_public_path__ + "static/media/smallLoader.11b66dfa.svg";